/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nature.vue?vue&type=template&id=3e6bcef2&scoped=true&"
import script from "./nature.vue?vue&type=script&lang=js&"
export * from "./nature.vue?vue&type=script&lang=js&"
import style0 from "./nature.vue?vue&type=style&index=0&id=3e6bcef2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6bcef2",
  null
  
)

export default component.exports